import { render, staticRenderFns } from "./TaxonomyActions.vue?vue&type=template&id=88c71d58&scoped=true&"
import script from "./TaxonomyActions.vue?vue&type=script&lang=ts&"
export * from "./TaxonomyActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c71d58",
  null
  
)

export default component.exports